import * as React from "react";
import { Link } from "react-router-dom";
import { RouteFactory } from "@app/routePaths";
import defaultLogo from "@assets/bt-logo-white-mobile.svg";
import cx from "classnames";

export type LogoProps = {
  src?: string;
  link?: string;
  alt?: string;
  rootClassName?: string;
  style?: React.CSSProperties;
};

export default function Logo({
  link = RouteFactory.home,
  src = defaultLogo,
  alt = "The Business Times",
  style = {},
  rootClassName = "",
}: LogoProps): React.ReactElement {
  return (
    <Link
      to={link}
      className={cx("block w-[195px] xs:w-[213px] sm:w-[225px]", rootClassName)}
      title={alt}
      reloadDocument
    >
      <img className="w-full" src={src} alt={alt} style={style} />
    </Link>
  );
}
